/**
 * Shared color palette - Todoist-inspired
 */
export const colors = {
  background: '#F9FAFB',     // gray-50
  card: '#FFFFFF',           // white
  textPrimary: '#111827',    // gray-900
  textSecondary: '#6B7280',  // gray-500
  border: '#E5E7EB',         // gray-200
  blue: {
    50: '#EFF6FF',
    100: '#DBEAFE',
    200: '#BFDBFE',
    300: '#93C5FD',
    400: '#60A5FA',
    500: '#3B82F6',
    600: '#2563EB',
    700: '#1D4ED8',
  },
  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
  },
  amber: {
    50: '#FFFBEB',
    100: '#FEF3C7',
    200: '#FDE68A',
    400: '#FBBF24',
    500: '#F59E0B',
    600: '#D97706',
    700: '#B45309',
  },
  red: {
    50: '#FEF2F2',
    100: '#FEE2E2',
    600: '#DC2626',
    700: '#B91C1C',
  },
  rose: {
    50: '#FFF1F2',
    100: '#FFE4E6',
    400: '#FB7185',
  },
  green: {
    50: '#F0FDF4',
    100: '#DCFCE7',
    200: '#BBF7D0',
    600: '#16A34A',
    700: '#15803D',
  },
  // AI Assistance colors
  purple: {
    50: '#FAF5FF',
    100: '#F3E8FF',
    500: '#A855F7',
    600: '#9333EA',
  },
  orange: {
    50: '#FFF7ED',
    100: '#FFEDD5',
    600: '#EA580C',
    700: '#C2410C',
  },
};

export default colors;

